import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  height: 100%;
  resize: none;
  background-color: ${({ theme }) => theme.colors.aquaHaze};
  border: ${({ theme }) => `1px solid ${theme.colors.mishka}`};
  border-radius: 4px;
  padding: 4rem;
`;
